import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

declare var $:any;

@Component({
  selector: 'app-shops',
  templateUrl: './shops.component.html',
  styleUrls: ['./shops.component.css']
})
export class ShopsComponent implements OnInit {

  pageName = "My Shops";

  constructor(private router: Router) { }

  ngOnInit() {

    $('#initialise-page').trigger('click');
  }

  createStore()
  {
  	this.router.navigate(['/sellers/account/create']);
  }

}
